<div class="flex flex-col gap-1">
  <dx-text-box
    [value]="formData.text"
    [placeholder]="'Titolo' | transloco"
    [readOnly]="readonly"
    (onValueChanged)="onTitleChanged($event)"
  ></dx-text-box>

  <snt-wysiwyg-editor
    #defaultContentEditor
    [engine]="WysiwygEngine.DEVX"
    [initialContent]="formData.default"
    [placeholder]="'Contenuto di default' | transloco"
    [readOnly]="readonly"
    (contentChanged)="onContentChanged()"
    class="border border-slate-200 rounded-md"
  ></snt-wysiwyg-editor>
</div>
